import { render, staticRenderFns } from "./TenderCurrent.vue?vue&type=template&id=6bcb0330&scoped=true&"
import script from "./TenderCurrent.vue?vue&type=script&lang=js&"
export * from "./TenderCurrent.vue?vue&type=script&lang=js&"
import style0 from "./TenderCurrent.vue?vue&type=style&index=0&id=6bcb0330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb0330",
  null
  
)

export default component.exports